import { mapGetters, mapMutations } from 'vuex';
import BundleSelector from './partials/bundle-selector';
import Projection from '../assets/partials/Projection';
import BundleCalendar from './partials/bundle-calendar';
import { scrollToFirstError } from '@jgile/laravel-vue/resources/js/util';

Vue.component('create-bundle', {
    components: { BundleCalendar, BundleSelector, Projection },
    data() {
        return {
            loading: false,
            asset: new SparkForm({
                status: 0,
                asset_type: null,
                name: null,
                start_date: null,
                end_date: null,
                bundle_assets: [],
            }),
            datePickerConfig: {
                minDate: new Date(),
                mode: 'range',
            },
        };
    },

    computed: {
        ...mapGetters('bundle', ['bundleAssets', 'bundleAssetsCount']),
        date: {
            get() {
                if (this.asset.start_date && this.asset.end_date) {
                    return {
                        start: this.asset.start_date,
                        end: this.asset.end_date,
                    };
                }

                return {};
            },
            set(newVal) {
                this.asset.start_date = newVal.start;
                this.asset.end_date = newVal.end;
            },
        },
    },

    methods: {
        ...mapMutations('bundle', ['addAsset', 'removeAsset']),

        saveAndNext() {
            this.save(function (response) {
                window.location = `/team/bundles/${response.data.id}/details`;
            });
        },
        saveAndStay() {
            this.save(function (response) {
                window.location = `/team/assets/${response.data.id}/edit`;
            });
        },
        save(callback = null) {
            const _this = this;
            this.asset.bundle_assets = _.map(this.bundleAssets, function (o) {
                return { asset_id: o.id };
            });

            Spark.post('/api/team/bundles', this.asset)
                .then((response) => {
                    if (callback) {
                        callback(response);
                    }
                })
                .catch(() => {
                    scrollToFirstError();
                });
        },
    },
});
